import route from "@/components/router/Router"
const routes = [
    {
        path : "land-item-add",
        name : "land-item-add",
        meta : {
            title : "土地项目-项目录入"
        },
        component: () => import('@/pages/land/input/Index')
    },
    {
        path : "land-item-edit/:id",
        name : "land-item-edit",
        meta : {
            title : "土地项目-项目录入"
        },
        component: () => import('@/pages/land/input/Index')
    }
];

export default routes;


// WEBPACK FOOTER //
// ./src/router/land/inputitem/index.js